
<div class="login-box">

  <h2 class="sign-in">{{ "SIGN_UP_HEADER" | translate }}</h2>
  <p class="login-desc">{{ "SIGN_IN_DESC" | translate }}</p>
</div>
<div class="login-form-elements">
  <form [formGroup]="signUpForm" (ngSubmit)="submit()">
    <div class="row">
      <div class="col-6">
        <mat-form-field
          appearance="standard"
          class="custom-input-field w-100 mb-3"
        >
          <mat-label>{{ "FIRST_NAME_PLACEHOLDER" | translate }}</mat-label>
          <img
            matPrefix
            src="./assets/icons/full_name.svg"
            alt="full name"
            draggable="false"
          />
          <input
            matInput
            type="text"
            placeholder=""
            formControlName="first_name"
            matInput
          />
          <mat-error
            *ngIf="
              signUpForm.controls['first_name'] &&
              signUpForm.controls['first_name'].hasError('pattern')
            "
          >
            {{ "FIRST_NAME_CONTAIN_CHAR" | translate }}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field
          appearance="standard"
          class="custom-input-field w-100 mb-3"
        >
          <mat-label>{{ "LAST_NAME_PLACEHOLDER" | translate }}</mat-label>
          <input
            type="text"
            class="ps-0"
            placeholder=""
            formControlName="last_name"
            matInput
          />
          <mat-error
            *ngIf="
              signUpForm.controls['last_name'] &&
              !signUpForm.controls['last_name'].hasError('required')
            "
          >
            {{ "LAST_NAME_CONTAIN_ONLY_CHAR" | translate }}</mat-error
          >
        </mat-form-field>
      </div>
      <div class="col-12">
        <mat-form-field
          appearance="standard"
          class="custom-input-field w-100 mb-3"
        >
          <mat-label>{{ "EMAIL_PLACEHOLDER" | translate }}</mat-label>
          <img
            matPrefix
            src="./assets/icons/login-email-logo.svg"
            alt="login-email-logo"
            draggable="false"
          />
          <input
            type="email"
            placeholder="{{ 'EMAIL_PLACEHOLDER' | translate }}"
            formControlName="email"
            [readonly]="patchMailSignUp"
            matInput
          />
          <mat-error
            *ngIf="
              signUpForm.controls['email'] &&
              signUpForm.controls['email'].hasError('pattern')
            "
          >
            {{ "INVALID_EMAIL" | translate }}</mat-error
          >
        </mat-form-field>
      </div>
      <div class="col-12">
        <mat-form-field
          appearance="standard"
          class="custom-input-field w-100 mb-3"
        >
          <img
            matPrefix
            src="./assets/icons/phoneicon.svg"
            alt="phone icon"
            draggable="false"
          />
          <ngx-mat-intl-tel-input
            formControlName="mobile_number"
            (countryChanged)="changeCountryCode($event)"
            placeholder=""
            [cssClass]="'custom'"
            [enableSearch]="true"
            name="phone"
            #phone
            [preferredCountries]="preferredCountries"
          >
          </ngx-mat-intl-tel-input>
          <mat-error
            *ngIf="!signUpForm.controls['mobile_number'].hasError('required')&&signUpForm.controls['mobile_number']?.errors?.['validatePhoneNumber']"
          >
            {{ "MOBILE_NUMBER_VALID_MSG" | translate }}</mat-error
          >
        </mat-form-field>
      </div>
      <div class="col-12">
        <mat-form-field
          appearance="standard"
          class="custom-input-field w-100 mb-3"
        >
          <mat-label>{{ "PASSWORD_PLACEHOLDER" | translate }}</mat-label>
          <img
            matPrefix
            src="./assets/icons/login-password-logo.svg"
            alt="login password logo"
            draggable="false"
          />
          <input
            type="password"
            placeholder=""
            [type]="showPassword ? 'text' : 'password'"
            matInput
            formControlName="password"
          />
          <img
            tabindex="0"
            (keypress)="$event.keyCode == 13 && togglePasswordVisibility()"
            [src]="
              showPassword
                ? './assets/icons/24.svg'
                : './assets/icons/login-show-pwd.svg'
            "
            (click)="togglePasswordVisibility()"
            alt="showPassword"
            matSuffix
            style="pointer-events: auto"
            draggable="false"
          />
          <mat-error
            *ngIf="
              signUpForm.controls['password'] &&
              !signUpForm.controls['password'].hasError('required')
            "
          >
            {{ "PASSWORD_PATTERN" | translate }}</mat-error
          >
        </mat-form-field>
      </div>
      <div class="col-12">
        <mat-form-field
          appearance="standard"
          class="custom-input-field w-100 mb-3 pt-3"
        >
          <mat-label>{{
            "CONFIRM_PASSWORD_PLACEHOLDER" | translate
          }}</mat-label>
          <img
            matPrefix
            src="./assets/icons/login-password-logo.svg"
            alt="login-password-logo"
            draggable="false"
          />
          <input
            type="password"
            placeholder=""
            [type]="confirmShowPassword ? 'text' : 'password'"
            matInput
            formControlName="confirmPassword"
          />
          <img
            tabindex="0"
            (keypress)="
              $event.keyCode == 13 && toggleConfirmPasswordVisibility()
            "
            [src]="
              confirmShowPassword
                ? './assets/icons/24.svg'
                : './assets/icons/login-show-pwd.svg'
            "
            (click)="toggleConfirmPasswordVisibility()"
            alt="showPassword"
            matSuffix
            style="pointer-events: auto"
            draggable="false"
          />
          <mat-error
            *ngIf="
              signUpForm.controls['confirmPassword'] &&
              !signUpForm.controls['confirmPassword'].hasError('required')
            "
          >
            {{ "CONFIRM_PASSWORD_NOT_MATCH_WITH_OLD" | translate }}</mat-error
          >
        </mat-form-field>
      </div>
    </div>
    <re-captcha
      (resolved)="addTokenLog('Normal mode resolved', $event)"
      formControlName="recaptcha"
    ></re-captcha>
    <div
      [hidden]="
        signUpForm.controls['recaptcha'] &&
        !signUpForm.controls['recaptcha'].hasError('required')
      "
      class="error"
    >
      {{ "CAPTCHA_REQUIRED" | translate }}
    </div>
    <div class="align-login-btn">
      <button
        type="button"
        class="btn blue-gredient-btn form-control w-100 justify-content-center"
        mat-button
        mat-flat-button
        (click)="submit()"
        [disabled]="!signUpForm.valid"
      >
        {{ "SIGN_UP_BTN" | translate }}
      </button>
    </div>
  </form>
  <p class="botom-action-line">
    {{ "ALREADY_HAVE_ACCOUNT" | translate }}
    <span class="sign-up-now" routerLink="/">{{
      "LOGIN_BTN" | translate
    }}</span>
  </p>
</div>